/**
* Provider to detect the language and locale preferences of the user
* @author Brendan Magee
*/

const has = Object.prototype.hasOwnProperty;

function languageProvider($windowProvider) {
  this.supportedLocales = new Set(['de', 'en', 'es', 'fr', 'ja', 'ko', 'nb', 'nn', 'no', 'sv', 'ar', 'pt']);

  this.getLanguage = () => {
    const $window = $windowProvider.$get();
    const defaultLocale = 'en-us';

    if (has.call($window, 'navigator')) {
      const [preferredLocale = defaultLocale] = $window.navigator.languages
        || [$window.navigator.language];

      // Convert browser locales to format expected by `angular-i18n`
      return this.supportedLocales.has(preferredLocale.slice(0, 2))
        ? preferredLocale.replace('_', '-').toLowerCase()
        : defaultLocale;
    }

    return defaultLocale;
  };

  const locale = this.getLanguage();
  const language = locale.substring(0, 2);

  this.$get = () => ({
    locale,
    language,
    getLanguage: this.getLanguage
  });
}

const arr = [
  '$windowProvider',
  languageProvider
];

module.exports = (ngModule) => {
  ngModule.provider('languageProvider', arr);
};
